/* eslint-disable import/no-unresolved */
import {
  KlevuKMCSettings,
  KlevuConfig,
  KlevuFetch,
  KlevuEvents,
  search,
  searchCms,
  suggestions,
} from 'https://cdn.skypack.dev/-/@klevu/core@v5.2.3-HNRf1HrJ9AqvnoHcX5mg/dist=es2019,mode=imports,min/optimized/@klevu/core.js'
const { debounce } = window.BAO.Utils

KlevuConfig.init({
  apiKey: `${window.theme.klevu.apiKey}`,
  url: `https://${window.theme.klevu.url}/cs/v2/search`,
})
class QuickSearch extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    this.loadQuickSearch()
  }

  setupListeners () {
    super.setupListeners()

    this.onPerformSearch = debounce(this.onPerformSearch.bind(this), 300)
    this.onClose = this.onClose.bind(this)
    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onTabClick = this.onTabClick.bind(this)
    this.handlePopularSearchClick = this.handlePopularSearchClick.bind(this)
    this.onProductClick = this.onProductClick.bind(this)
    this.onExternalInputClick = this.onExternalInputClick.bind(this)

    this.externalEls?.trigger?.elements.forEach((el) => {
      this.listeners.add(el, 'click', this.onTriggerClick)
    })

    this.externalEls?.close?.elements.forEach((el) => {
      this.listeners.add(el, 'click', this.onClose)
    })

    this.externalEls?.input?.elements.forEach((el) => {
      this.listeners.add(el, 'click', this.onExternalInputClick)
    })

    if (this.els?.backdrop?.exists) {
      this.listeners.add(this.els.backdrop.element, 'click', this.onClose)
    }

    this.listeners.add(document, 'click', this.onTabClick)
    this.listeners.add(document, 'click', this.handlePopularSearchClick)

    document.addEventListener('nav-open', this.onClose)
    document.addEventListener('drawer-open', this.onClose)
  }

  loadQuickSearch () {
    return window.BAO.sectionRenderer
      .fetchSingle('quick-search')
      .then(async (res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const DOMSection = newDOM.querySelector('section')

        if (DOMSection) {
          this.els.container.element.innerHTML = `${DOMSection.outerHTML}`

          this.els?.input?.elements.forEach((inputEl) => {
            this.listeners.add(inputEl, 'keyup', this.onPerformSearch)
          })

          this.externalEls?.input?.elements.forEach((inputExternalEl) => {
            this.listeners.add(inputExternalEl, 'keyup', this.onPerformSearch)
          })

          const settings = await KlevuKMCSettings()

          const popularSearches = settings.root.klevu_webstorePopularTerms
            .map((suggestion) => {
              return `<a data-quick-search-el="popular-item" href="${window.Shopify.routes.root}search?q=${suggestion}" class="sec-QuickSearch_SuggestionButton" data-value="${suggestion}">${suggestion}</a>`
            })
            .join('')
          this.els.popular.element.innerHTML = popularSearches
        }
      })
      .catch(() => {
        return null
      })
  }

  onExternalInputClick () {
    if (window.drawers.activeDrawerKey === '') return

    window.drawers.activeDrawerKey = ''
    this.onTriggerClick()
  }

  onProductClick (event) {
    const product = event.target.closest('[data-klevu-search-product]')

    const productClickData = {
      product: {
        id: `${product.dataset.productId}`,
        name: `${product.dataset.productName}`,
        url: `${product.dataset.productUrl}`,
      },
      searchTerm: `${this.searchTerm}`,
    }

    KlevuEvents.searchProductClick(productClickData)
  }

  onTabClick (event) {
    const tab = event.target.closest('[data-quick-search-el="tab"]')

    if (!tab) return

    if (tab.dataset.value === 'cms') {
      this.els['cms-wrapper'].element.setAttribute('aria-hidden', 'false')
      this.els['product-wrapper'].element.setAttribute('aria-hidden', 'true')
    }

    if (tab.dataset.value === 'products') {
      this.els['cms-wrapper'].element.setAttribute('aria-hidden', 'true')
      this.els['product-wrapper'].element.setAttribute('aria-hidden', 'false')
    }
  }

  handlePopularSearchClick (event) {
    const popularSearchLink = event.target.closest(
      '[data-quick-search-el="popular-item"]',
    )

    if (!popularSearchLink) return

    event.preventDefault()

    this.els.input.element.value = event.target.dataset.value
    this.externalEls.input.element.value = event.target.dataset.value

    if (window.BAO.MediaBreakpoints.isMd) {
      this.els.input.element.focus()

      this.els.input.element.dispatchEvent(new KeyboardEvent('keyup'))
    } else {
      this.externalEls.input.element.focus()

      this.externalEls.input.element.dispatchEvent(new KeyboardEvent('keyup'))
    }
  }

  onTriggerClick () {
    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SearchOpen')
    this.externalEls?.close?.elements.forEach((closeEl) => {
      closeEl.setAttribute('aria-hidden', 'false')
    })
    this.externalEls?.trigger?.elements.forEach((triggerEl) => {
      triggerEl.setAttribute('aria-hidden', 'true')
    })

    if (window.BAO.MediaBreakpoints.isMd) {
      window.setTimeout(() => {
        this.els.input.element.focus()
      }, 500)
    } else {
      // Align temp input element approximately where the input element is
      // so the cursor doesn't jump around
      const tempInputEl = document.createElement('input')
      tempInputEl.style.position = 'absolute'
      tempInputEl.style.top = `${this.externalEls.input.element.offsetTop + 7}px`
      tempInputEl.style.left = `${this.externalEls.input.element.offsetLeft}px`
      tempInputEl.style.height = 0
      tempInputEl.style.opacity = 0
      // Put this temp element as a child of the page <body> and focus on it
      document.body.appendChild(tempInputEl)
      tempInputEl.focus()

      // The keyboard is open. Now do a delayed focus on the target element
      window.setTimeout(() => {
        this.externalEls.input.element.focus()
        this.externalEls.input.element.click()
        // Remove the temp element
        document.body.removeChild(tempInputEl)
      }, 500)
    }
  }

  onClose () {
    this.setAttribute('aria-hidden', 'true')

    this.els.input.element.value = ''
    this.externalEls.input.element.value = ''
    this.onEmptyInput()

    document.body.classList.remove('util-SearchOpen')

    this.externalEls?.close?.elements.forEach((closeEl) => {
      closeEl.setAttribute('aria-hidden', 'true')
    })
    this.externalEls?.trigger?.elements.forEach((triggerEl) => {
      triggerEl.setAttribute('aria-hidden', 'false')
    })
  }

  onPerformSearch (event) {
    const searchTerm = event.target.value

    this.lastActiveInput = event.target

    if (searchTerm.length < 3) {
      this.onEmptyInput()
    } else {
      this.loadResults(searchTerm)
    }
  }

  onEmptyInput () {
    this.els.layout.element.setAttribute('aria-hidden', 'false')
    this.els['no-results'].element.setAttribute('aria-hidden', 'true')

    this.els['suggestions-container'].element.setAttribute(
      'aria-hidden',
      'true',
    )

    this.els['default-suggestion'].elements.forEach((defaultSuggestionEl) => {
      defaultSuggestionEl.setAttribute('aria-hidden', 'false')
    })
    this.els.footer.element.setAttribute('aria-hidden', 'false')

    this.els['results-main'].element.setAttribute('aria-hidden', 'true')
    this.els['default-main'].element.setAttribute('aria-hidden', 'false')
  }

  onNoResults () {
    this.els.layout.elements.forEach((layoutEl) => {
      layoutEl.setAttribute('aria-hidden', 'true')
    })

    this.els['no-results'].element.setAttribute('aria-hidden', 'false')

    this.els['default-suggestion'].elements.forEach((defaultSuggestionEl) => {
      defaultSuggestionEl.setAttribute('aria-hidden', 'false')
    })
    this.els.footer.element.setAttribute('aria-hidden', 'false')
  }

  attachProductClickListeners () {
    const productEls = this.els.results.element.querySelectorAll(
      '[data-klevu-search-product]',
    )
    productEls.forEach((productEl) => {
      productEl.addEventListener('click', this.onProductClick)
    })
  }

  async loadResults (searchTerm) {
    const result = await KlevuFetch(
      suggestions(searchTerm, {
        id: 'suggestions',
      }),
      search(searchTerm, {
        id: 'search',
        fields: ['url'],
        limit: 6,
      }),
      searchCms(searchTerm, {
        id: 'page',
      }),
    )

    const suggestionRecords =
      result.suggestionsById('suggestions')?.suggestions
    const records = result.queriesById('search')?.records
    const recordsTotal = result.queriesById('search').meta.totalResultsFound
    const pageRecords = result.queriesById('page')?.records
    const pageRecordsTotal = result.queriesById('page').meta.totalResultsFound

    if (records || pageRecords) {
      this.setupResults(
        records,
        recordsTotal,
        searchTerm,
        pageRecords,
        pageRecordsTotal,
      )
    }

    if (suggestionRecords) {
      this.setupSuggestions(suggestionRecords)
    }
  }

  async setupSuggestions (suggestionRecords) {
    const suggestionHTML = await this.getSuggestionHTML(suggestionRecords)

    this.els.suggestions.element.innerHTML = suggestionHTML

    this.els['suggestions-container'].element.setAttribute(
      'aria-hidden',
      suggestionRecords.length < 1 ? 'true' : 'false',
    )
  }

  async getSuggestionHTML (suggestionRecords) {
    const stripHTML = (html) => {
      return html.replace(/<\/?[^>]+(>|$)/g, '')
    }

    const suggestionHTML = await Promise.all(
      suggestionRecords.map(async (suggestion) => {
        const strippedSuggestion = stripHTML(suggestion.suggest)

        return `
        <a href="${window.Shopify.routes.root}search?q=${strippedSuggestion}" class="sec-QuickSearch_SuggestionButton">${suggestion.suggest}</a>
        `
      }),
    )

    return suggestionHTML.filter(Boolean).join('')
  }

  async setupResults (
    records,
    recordsTotal,
    searchTerm,
    pageRecords,
    pageRecordsTotal,
  ) {
    this.els['results-main'].element.setAttribute('aria-hidden', 'false')

    this.els['default-main'].element.setAttribute('aria-hidden', 'true')

    const hasAnyRecords = records.length > 0 || pageRecords.length > 0

    if (!hasAnyRecords) {
      this.onNoResults()

      return
    }

    this.els.layout.elements.forEach((layoutEl) => {
      layoutEl.setAttribute('aria-hidden', 'false')
    })

    this.els['no-results'].element.setAttribute('aria-hidden', 'true')

    this.setAttribute('aria-busy', 'true')

    this?.els?.tab?.elements.forEach((tabEl) => {
      if (tabEl.dataset.value === 'cms') {
        tabEl.setAttribute('aria-hidden', pageRecords.length === 0)
      }
      if (tabEl.dataset.value === 'products') {
        tabEl.setAttribute('aria-hidden', records.length === 0)
      }
    })

    if (pageRecords.length > 0) {
      const pageHTML = await this.getPageHTML(pageRecords)
      this.els['cms-results'].element.innerHTML = pageHTML

      this.els['cms-count'].elements.forEach((countEl) => {
        countEl.textContent = `${pageRecordsTotal}`
      })
    }

    if (records.length > 0) {
      const productCardHTML = await this.getAllProductCardHTML(records)
      this.els.results.element.innerHTML = productCardHTML

      this.els.count.elements.forEach((countEl) => {
        countEl.textContent = `${recordsTotal}`
      })

      const viewAllHTML = `<a href='${window.Shopify.routes.root}search?q=${searchTerm}' class="btn-Button btn-Button-primary btn-Button-outline btn-Button-small">
      ${window.theme.klevu.results}
      </a>`

      this.els['view-all'].element.innerHTML = viewAllHTML

      this.attachProductClickListeners()
    }

    if (pageRecords.length > 0 && records.length === 0) {
      this.els['cms-wrapper'].element.setAttribute('aria-hidden', 'false')
      this.els['product-wrapper'].element.setAttribute('aria-hidden', 'true')
    }

    this.els['default-suggestion'].elements.forEach((defaultSuggestionEl) => {
      defaultSuggestionEl.setAttribute('aria-hidden', 'true')
    })

    if (!window.BAO.MediaBreakpoints.isMd) {
      this.els.footer.element.setAttribute('aria-hidden', 'true')
    }

    this.setAttribute('aria-busy', 'false')
  }

  async getPageHTML (pageRecords) {
    if (!pageRecords || pageRecords.length === 0) return ''
    const pageHTML = await Promise.all(
      pageRecords.map((page) => {
        return `
          <a href="${page.url}" class="sec-QuickSearch_PageResult fz-24_130">
            ${page.name}
          </a>
        `
      }),
    )
    return pageHTML.filter(Boolean).join('')
  }

  async getAllProductCardHTML (records) {
    const productCardHTML = await Promise.all(
      records.map(
        async (product, index) => await this.getProductCardHTML(product, index),
      ),
    )
    return productCardHTML.filter(Boolean).join('')
  }

  async getProductCardHTML (product, index) {
    const productUrl = product.url.replace(
      '/products/',
      `${window.Shopify.routes.root}products/`,
    )

    return window.BAO.sectionRenderer
      .fetchSingle('search-product-card', `${productUrl}`)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const card = newDOM.querySelector('article')

        if (card) {
          return `<div class="sec-QuickSearch_Result">${card.outerHTML}</div>`
        }
      })
      .catch(() => {
        return null
      })
  }
}

if (!customElements.get('quick-search')) {
  customElements.define('quick-search', QuickSearch)
}
